// extracted by mini-css-extract-plugin
export var animationContainer = "_n7-0";
export var footer = "_n7-1";
export var gray = "_n7-2";
export var lineItem = "_n7-3";
export var lineItemImage = "_n7-4";
export var lineItemInfo = "_n7-5";
export var lineItemText = "_n7-6";
export var lineItems = "_n7-7";
export var modalContent = "_n7-8";
export var options = "_n7-9";
export var orderName = "_n7-a";
export var refundAmount = "_n7-b";